import { AppDispatch } from '..';
import { loginAdmin, getMe, setToken, removeToken } from '../../api/AdminAPI';
import { setAuth, setLoading, setError, clearAuth } from '../reducers/auth.reducer';

export const loginThunk = (email: string, password: string) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await loginAdmin(email, password);
    const { token, user } = response.data;
    setToken(token);
    dispatch(setAuth({ user, token }));
  } catch (error: any) {
    console.error('Login error:', error);
    const message = error.response?.data?.error || error.message || 'Login failed';
    dispatch(setError(message));
  }
};

export const verifySessionThunk = () => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await getMe();
    const token = localStorage.getItem('admin_token');
    dispatch(setAuth({ user: response.data.user, token: token! }));
  } catch {
    removeToken();
    dispatch(clearAuth());
  }
};

export const logoutThunk = () => (dispatch: AppDispatch) => {
  removeToken();
  dispatch(clearAuth());
};
